// extracted by mini-css-extract-plugin
export default {"container":"StorageSettingsUI_container__1Y4I6"};